<template>
  <div class= 'card box pt-4 pb-2'>
    <b-container>
      <b-row>
        <b-col cols=12>
          <h5 class='text-center title'> {{item.title}}</h5>
        </b-col>
        <b-col cols=12>
          <h5 class='text-right value'> {{item.value}}</h5>
        </b-col>
        <b-col cols=12>
          <h6 class='text-right symbol'> {{item.symbol}}</h6>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  props: [
    'item'
  ]
}
</script>

<style scoped>
.box .title {
  font-family: "Poppins-Light";
  font-style: normal;
  font-weight: bold;
  /*font-size: 12px;*/
  line-height: 18px;
  color: #FFF9BC;
}
.box .value {
  font-style: normal;
  /*font-weight: bold;*/
  color: #FFF;
  margin-bottom: 0px;
}

.box .symbol{
  font-family: "Poppins-Light";
  font-style: normal;
  font-weight: 500;
  /*font-size: 12px;*/
  line-height: 18px;
  margin-bottom: 0px;
  color: #A7A4A4;
}
.box {
  background-color: #1E1E1E !important;
}
</style>
